import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["adapter", "budget"]

  connect() {
    this.updateAdapter()
  }

  updateAdapter() {
    const key = (this.adapterTarget.value || "").split("@")[0]
    const http = key === "http" || key === "zoho_books"
    this.budgetTargets.forEach((el) => el.classList.toggle("hidden", !http))
  }
}
